import { IMoviesShortsDetails } from "@Types/movies";
import { useSetState } from "ahooks";
import { SetState } from "ahooks/lib/useSetState";
import React from "react";
import { useEffect, useMemo, useState } from "react";
import BuyCarLarge from "./BuycarLarge";
import BuyCarMini from "./BuycarMini";

/** 广告类型 */
export enum AdvertisementType {
  INQUIRY = "inquiry",
  VOTE = "vote",
  PK = "pk",
  BuyCarMenu = "buyCarMenu",
  SHOP_AD = "shopAd",
  SHOP_COMMON = "shopCommon",
  AGENT = "agent",
}

/** 处理广告显示逻辑 */
export const useAdvertisementShow = (
  defaultData?: IMoviesShortsDetails,
): [number, SetState<{ data: IMoviesShortsDetails; currentTime: number }>] => {
  const [{ data, currentTime }, updateData] = useSetState<{ data?: IMoviesShortsDetails; currentTime: number }>({
    data: defaultData,
    currentTime: 0,
  });
  // 展示逻辑，1为轻提示，2为展开，3为1+2组合，0为不显示
  const [showFlag, setShowFlag] = useState<number>(0);
  useEffect(() => {
    if (data?.bring?.type && data.bring[data.bring.type]) {
      const { showTimes } = data.bring[data.bring.type];
      const { flag } = data.bring;
      // 还原
      if (showFlag > 1 && currentTime === 0) {
        setShowFlag(0);
      }
      if (typeof showTimes === "number" && showFlag === 0) {
        // 初始时显示轻提示
        setShowFlag((flag & 1) === 1 ? 1 : 2);
      } else if (typeof showTimes === "number" && showFlag !== 0 && flag >> 1 && currentTime > showTimes) {
        // 初始时显示轻提示
        setShowFlag(flag);
      }
    }
  }, [currentTime, data, showFlag]);
  return [showFlag, updateData];
};

const DetailsAdvertisement: React.FC<{ bring: IMoviesShortsDetails["bring"]; showFlag: number; data?: any }> = ({
  bring,
  showFlag,
  data,
}) => {
  const [show, setShow] = useState(true);
  const [showClick, setShowClick] = useState(false);

  const { type, flag, agent, buyCarMenu } = bring || {};

  // 显示详情版
  const isShowDetail = flag && Boolean((flag >> 1) & 1) && Boolean((showFlag >> 1) & 1) && show;
  // 显示简略版
  const isShowBrief = flag && (flag & 1) === 1 && (showFlag & 1) === 1;

  const handleCloseClick = (v: boolean) => {
    setShowClick(v);
    setShow(v);
  };

  const componentsShowMap = useMemo(() => {
    return {
      buyCarMenu_detail: isShowDetail && type === AdvertisementType.BuyCarMenu,
      buyCarMenu: isShowBrief && type === AdvertisementType.BuyCarMenu,
    };
  }, [isShowBrief, isShowDetail, type, flag]);

  const comp = useMemo(() => {
    const showComp = Object.entries(componentsShowMap)?.find((item) => !!item[1]);
    if (showComp) {
      const [key] = showComp;
      switch (key as keyof typeof componentsShowMap) {
        case "buyCarMenu":
          return <BuyCarMini data={buyCarMenu} />;
        case "buyCarMenu_detail":
          return <BuyCarLarge data={buyCarMenu} visible={show} setVisible={setShow} />;

        default:
          return <></>;
      }
    }
    return <></>;
  }, [agent, componentsShowMap, buyCarMenu, show, showClick]);

  if (!bring) return <></>;

  return (
    <div id='details-advertisement' className='absolute left-12 bottom-70 z-99'>
      {comp}
    </div>
  );
};

export default DetailsAdvertisement;
